import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useLocation, Form, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { changeStatus, getCheckList, getReservation, postBooking } from "net/b2b";
import { IBooking, ICheckListData } from "dataModels/b2b";
import BookingSlotDetail from "views/b2bView/components/bookingData/components/bookingSlotDetail"
import BookingReservationDetail from "views/b2bView/components/bookingData/components/bookingReservationDetail";
import BookingReservationForm from "views/b2bView/components/bookingData/components/bookingReservationForm";
import { Button, Select, ActionButton } from "@ds/ds-snam/react";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { AppUserGrant, AppUserRole, CalendarSlotStatus, DsLayout, EntityType, FormMode, IAppUserProfile, ReservationPostType, ResponseCode, ResponseStatus, RoutePath, SNAM_PLANTS, SnamPlantKey, SupplyingResultIdStatus } from "shared/constants";
import { Col, Container, Row } from "react-grid-system";
import { dsPreSelectHandler, dsSelectHandler } from "shared/utils/dsComponentUtils";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import MyBookingModal from "./bookingData/components/myBookingModal";
import useAppUser from "hooks/useAppUser";
import { buildPopUp } from "components/PopUp";
import { RootState } from "state/appStore";
import { AppUser } from "ooAuth2/appUser";
import { getMoveReservationParams } from "net/settings";
import { IMoveReservationParameters } from "dataModels/settings";

const BookingData: React.FC = (): JSX.Element => {
    const { t, i18n } = useTranslation(['b2b', 'app']);
    const { codeIup } = useParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const [bookingData, setBookingData] = useState<IBooking | undefined>();
    const [ formCheckListData,setFormCheckListData ] = useState<ICheckListData|undefined>();
    const [viewCancelReservationModal, setViewCancelReservationModal] = useState(false);
    const navigate = useNavigate();
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const [formMode, setFormMode] = useState<FormMode>(FormMode.READ);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const [moveData,setMoveData] = useState<IMoveReservationParameters | undefined>(undefined);
    const appUserProfile: IAppUserProfile | undefined = useAppUser()?.userProfile;
    const [switchToCoolDownModalVisible,setSwitchToCoolDownModalVisible] = useState(false);

    const loadData = useCallback(() => {
        dispatch(requestPending());
        getReservation(codeIup!)
            .then((response: IBooking) => {
                if (response.shipperId === "" &&
                    response.truckTractor === "" &&
                    response.tankerTruck === "" &&
                    response.isoContainer === "" &&
                    response.flatBed === "" &&
                    response.driverId === "" &&
                    response.destinationAddress === "" &&
                    response.destinationNation === "" &&
                    //da qui in poi
                    response.transporterId === ""  && 
                    response.destinationStreetNumber === "" &&
                    response.destinationPostalCode === "" &&
                    response.destinationCity === "" &&
                    response.destinationProvince === "" && 
                    response.destinationTime === "00:00" &&
                    /*response.secondaryDestination.length === 0 &&*/
                    response.crossedNation.length === 0
                    ) {
                    setFormMode(FormMode.NEW)
                }
            /*let mock:IBooking = {
    "codeIup": "f2fb848a-c243-4185-8652-2b13cf65d3ae",
    "reservationCode": "20261022-A-001",
    "date": 1792620000,
    "time": "06:00-10:00",
    "status": CalendarSlotStatus.PENDING,
    "jarvisAvailable": 2,
    "jarvisShipper": 2,
    "typeVehicle": 1,
    "truckTractor": "",
    "tankerTruck": "",
    "isoContainer": "",
    "flatBed": "",
    "driverId": "",
    "forcedBay": "-1",
    "bay": "",
    "destinationAddress": "",
    "destinationStreetNumber": "",
    "destinationPostalCode": "",
    "destinationCity": "",
    "destinationProvince": "",
    "destinationNation": "",
    "destinationBusinessName": "",
    "destinationVat": "",
    "crossedNation": [],
    "secondaryDestination": [],
    "destinationTime": "00:00",
    "businessName": "Cliente11",
    "service": 0,
    "shipperId": "1",
    "shipperName": "",
    "transporterId": "",
    "transporterName": "",
    "supplyingResultId": -1,
    "supplyingResultNote": "",
    "longTermTimeStamp": 1792152000,
    "freezingTimeStamp": 1792684800,
    "salesFreezingTimeStamp": 1792684800,
    "closedLoadMass": null,
    "closedLoadEnergy": null,
    "closedDensity": null,
    "closedStandardDensity": null,
    "closedNormalConditionDensity": null,
    "closedExpansionFactor": null,
    "closedHeatCombustionMass": null,
    "closedHeatCombustionVolume": null,
    "loadingCertificate": {
        "type": "transporter",
        "name": "truckInspection.pdf",
        "size": 4560,
        "content": "truckInspection content",
        "expire": null,
        "status": 0
    },
    "transporterDeleted": false,
    "truckTractorDeleted": false,
    "tankerTruckDeleted": false,
    "flatBedDeleted": false,
    "isoContainerDeleted": false,
    "driverDeleted": false,
    "truckTractorPlate": "",
    "tankerTruckPlate": "",
    "flatBedPlate": "",
    "isoContainerCode": "",
    "driverFirstName": "",
    "driverLastName": "",
    "bayAssignmentAttemptSuccess": null,
    "preventiveQuantity": null,
    "preventiveEnergy": null,
    "shipperMediatorName": "Jarvis",
    "coolDownTmacWAavailable": false,
    "coolDownTmacWAchecked": false,
    "accessCode": 164,
    "shipperAggrShipper": 2,
    "shipperAggrAvailable": 2,
    "dailyGasPrice": null,
    "finalBusiness": null,
    "insertUserName": "Mattone Andrea",
    "lastMinute": false,
     "bioFlagStatus":true,
    "bioFlagDisabled":false,
    "percentageBioLng":0
}
                setBookingData(mock)*/
                setBookingData(response);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine())
            })
    }, [dispatch, codeIup]);

    const loadCheckListData =()=>{
        if(bookingData /*&& bookingData.bay !== ""*/ && (bookingData.status===CalendarSlotStatus.CONFIRMED || bookingData.status===CalendarSlotStatus.CLOSED)){
            dispatch(requestPending());
            getCheckList(codeIup!)
                .then((response: any) => {
                    setFormCheckListData(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                })
        }
    }

    useEffect(() => {
        if(bookingData!==undefined){
            loadCheckListData();
        }
    }, [bookingData]);
    
    const loadMoveData = useCallback(() => {
            dispatch(requestPending());
            getMoveReservationParams()
                .then((data: IMoveReservationParameters) => {
                    setMoveData(data);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                });
        }, [dispatch]);

    useEffect(() => {
        if (codeIup) {
            loadData();
            loadMoveData();
            //loadCheckListData();
        }
    }, [codeIup, loadData,loadMoveData]);



    const saveReservationModalData = () => {
        changeStatus(bookingData!.codeIup, EntityType.RESERVATION, 7, '')
            .then((response) => {
                
                /*let popUpAction: INotificationAction;
                const popUpTitle: string = response.data.status === ResponseStatus.ERROR ? t("booking.bookingDeleteModal.9") : (response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? t("booking.bookingDeleteModal.8") : t("booking.bookingDeleteModal.4"));
                const popUpDescription: string = response.data.status === ResponseStatus.ERROR || response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? response.data.message : t("booking.bookingDeleteModal.5");
                const popUpStatus: NotificationsStatusType = response.data.status === ResponseStatus.ERROR ? "error" : (response.data.code === ResponseCode.UNPROCESSABLE_CONTENT ? "warning" : "confirm");
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));*/
                buildPopUp(dispatch,response,t,t("booking.bookingDeleteModal.9"),t("booking.bookingDeleteModal.8"),t("booking.bookingDeleteModal.4"),t("booking.bookingDeleteModal.5"))
                
                setViewCancelReservationModal(false);
                navigate(RoutePath.B2B_BOOKINGS_INFO);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }

    const saveSwitchToCoolDown = () => {
        if(bookingData){
            const myFormData: IBooking = {
            ...bookingData,
            coolDownTmacWAchecked: true,
            service: 1,
            };
            postBooking(ReservationPostType.UPDATE_DETAILS,myFormData)
            .then((response) => {
                buildPopUp(dispatch,response,t,t("booking.bookingForm.labels.16"),'OK-422',t("booking.bookingForm.labels.11"),t("booking.bookingForm.labels.12"))
                navigate(RoutePath.B2B_BOOKINGS_INFO);
            })
            .catch(error => {
                let popUpAction: INotificationAction;
                popUpAction = {
                    show: true,
                    title: "Error",
                    description: error,
                    status: "error",
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                console.log(error);
                navigate(RoutePath.B2B_BOOKINGS_INFO);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
        }
    }

    return bookingData ?
        <>
            <p className="pageTitle">{t('booking.bookingData.headers.0')} {/*bookingData.codeIup*/bookingData.reservationCode}</p>
            {
            (
                (
                    /*bookingData.bay !== "" &&*/ 
                    (bookingData.status===CalendarSlotStatus.CONFIRMED || bookingData.status===CalendarSlotStatus.CLOSED)
                    &&
                    appUserRole!==AppUserRole.ACCESS_STAFF
                )
            )&&
                <div className="box" style={{ background: 'unset' }}>
                    <Row style={{ marginTop: '-60px' }}>
                        <Col xs={12} md={8}></Col>
                        <Col xs={12} md={4}>
                            <div style={{ marginTop: '20px', float: 'right' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '80%', fontFamily: 'Lato, Lato-local, sans-serif', marginBottom: '5px',color:layoutMode===DsLayout.DARK_MODE?"white":"black" }}>Checklist</div>
                                <ActionButton
                                    actionsType="button"
                                    buttonLabel={t('calendar.popups.buttons.0')}//"Azioni"
                                    buttonVariant="primary"
                                    menuActions={
                                        [
                                            {
                                                id: FormMode.EDIT.toString(),
                                                label: t('calendar.popups.buttons.11'),
                                                isDisabled: (!appUserProfile?.checklistGrants.includes(AppUserGrant.EDIT) || formCheckListData?.codeIupCorrispondence!==null || !(bookingData.status===CalendarSlotStatus.CONFIRMED))
                                            },
                                            {
                                                id: FormMode.READ.toString(),
                                                label: t('calendar.popups.buttons.10'),
                                                isDisabled: !appUserProfile?.checklistGrants.includes(AppUserGrant.READ) || formCheckListData?.codeIupCorrispondence===null
                                            }
                                        ]
                                    }
                                    closeMenuAriaLabel="close menu aria text"
                                    onClickAction={(event: Event) => {
                                        const command = (event as CustomEvent).detail.actionId;
                                        navigate(RoutePath.B2B_CHECKLIST + `/${bookingData.codeIup}`, { state: { command: command } });
                                        /*console.log(!appUserProfile?.checklistGrants.includes(AppUserGrant.EDIT))
                                        console.log(formCheckListData?.codeIupCorrispondence!==null)
                                        console.log(!(bookingData.status===CalendarSlotStatus.CONFIRMED))
                                        console.log((!appUserProfile?.checklistGrants.includes(AppUserGrant.EDIT) || formCheckListData?.codeIupCorrispondence!==null || !(bookingData.status===CalendarSlotStatus.CONFIRMED)))
                                        */
                                    }}
                                ></ActionButton>
                            </div>
                        </Col>
                    </Row>
                </div>
            }
            <BookingSlotDetail bookingData={bookingData} />

            {(
                (   
                    location.state.edit 
                || 
                    ( //OPPURE VEDO IL PULSANTE DI EDIT SE LA BAIA E' STATA ASSEGNATA (OVVERO E' PASSATA LA FREEZING DATE), MA LA PRENOTAZIONE NON E' ANCORA CHIUSA
                        /*bookingData.bay!=="" &&*/
                        appUserProfile?.reservationGrants.includes(AppUserGrant.EDIT) 
                        /*&& bookingData.status!==CalendarSlotStatus.CLOSED*/
                    )
                ) 
                &&
                appUserRole!==AppUserRole.ACCESS_STAFF
            )
             ?
                <>
                    {((formMode === FormMode.EDIT || (formMode === FormMode.NEW &&(bookingData.status!==CalendarSlotStatus.CANCELLED&&bookingData.status!==CalendarSlotStatus.CLOSED)))&&appUserProfile?.reservationGrants.includes(AppUserGrant.EDIT)) ?
                        <BookingReservationForm bookingData={bookingData} edit={location.state.edit} formMode={formMode} />
                        :
                        <BookingReservationDetail bookingData={bookingData} edit={location.state.edit} changeEditView={setFormMode} />
                    }
                </>
                :
                <BookingReservationDetail bookingData={bookingData} edit={location.state.edit} changeEditView={setFormMode} />
            }
            {appUserProfile?.reservationGrants.includes(AppUserGrant.DELETE) &&
                (bookingData.status !== CalendarSlotStatus.CLOSED && (formMode === FormMode.READ||formMode===FormMode.NEW)) &&
                (bookingData.status !== CalendarSlotStatus.CANCELLED && bookingData.status !== CalendarSlotStatus.SLOT_DELETED)
                &&
                <Button
                    style={{ float: 'right', marginTop: '20px' }}
                    id="backButton"
                    buttonType="button"
                    buttonUIVariant="secondary"
                    buttonSize="medium"
                    buttonLabel={t("booking.bookingDeleteModal.7")}//"Annulla prenotazione"
                    buttonIcon=""
                    isDisabled={false}
                    onClickEvent={() => {
                        setViewCancelReservationModal(true);
                    }}
                />
            }
            {appUserProfile?.reservationGrants.includes(AppUserGrant.CLONE) &&
                ((!location.state.edit || (location.state.edit && (formMode === FormMode.READ))) && bookingData.status !== CalendarSlotStatus.CLOSED) &&
                (bookingData.status !== CalendarSlotStatus.CANCELLED && bookingData.status !== CalendarSlotStatus.SLOT_DELETED)
                &&
                <>
                    <Button
                        style={{ float: 'right', marginTop: '20px', marginRight: '20px' }}
                        id="backButton"
                        buttonType="button"
                        buttonUIVariant="primary"
                        buttonSize="medium"
                        buttonLabel={t("booking.cloneSlot.5")}//"Clona prenotazione"
                        buttonIcon=""
                        isDisabled={( (appUserRole===AppUserRole.CUSTOMER||appUserRole===AppUserRole.CARRIER) && moveData)?(!(moveData.isActive)):false}
                        onClickEvent={() => {
                            navigate(RoutePath.B2B_CLONE_RESERVATION + `/${bookingData.codeIup}`, { state: { bookingData: bookingData } });
                        }}
                    />
                </>
            }
            {(appUserProfile?.reservationGrants.includes(AppUserGrant.EDIT) 
            && bookingData.coolDownTmacWAchecked===false 
            && bookingData.coolDownTmacWAavailable===true
            ) &&
                <>
                    <Button
                        style={{ float: 'right', marginTop: '20px', marginRight: '20px' }}
                        id="coolDownButton"
                        buttonType="button"
                        buttonUIVariant="primary"
                        buttonSize="medium"
                        buttonLabel={t("booking.bookingSwitchToCoolDownModal.2")}
                        buttonIcon=""
                        isDisabled={
                            (bookingData.coolDownTmacWAavailable===undefined||bookingData.coolDownTmacWAavailable===null) ? //se è valorizzato
                                false
                            : 
                            (
                                (bookingData.coolDownTmacWAavailable===true) ? //se è true allora posso fare il cooldown
                                    false 
                                :
                                    true
                            )
                        }
                        onClickEvent={() => {
                            setSwitchToCoolDownModalVisible(true);
                        }}
                    />
                </>
            }
            {switchToCoolDownModalVisible &&
                <MyBookingModal type={'switchToCoolDownModal'} onClose={() => setSwitchToCoolDownModalVisible(false)} saveData={saveSwitchToCoolDown} />
            }
            {viewCancelReservationModal &&
                <MyBookingModal type={'cancelReservationModal'} onClose={() => setViewCancelReservationModal(false)} saveData={saveReservationModalData} />
            }
        </>
        :
        <></>
}
export default BookingData;